import autobind from 'core-decorators/lib/autobind';

import { notForPreview } from 'widget/utils/not-for-preview';

import Button from 'widget/components/button/button';
import PropTypes from 'prop-types';
import Icon from 'shared/components/icon/icon';
import BaseOverlay from './_base-overlay';


export default class OverlayMemberOnlyBase extends BaseOverlay {

  static displayName = 'OverlayMemberOnlyBase';

  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
  };

  @autobind
  @notForPreview
  callPlayCallback() {
    const { videoItem: { id }, onPlayClick } = this.props;
    onPlayClick(id);
  }


  get buttonStyleName() {
    return 'button';
  }

  get playButton() {
    const playButtonText = this.playButtonText;

    return (
      <Button styleName={this.buttonStyleName}
              onClick={this.callPlayCallback}>
        <Icon styleName="play-icon"
              name="arrow-right-filled" />
        <span>
          { playButtonText }
        </span>
      </Button>
    );
  }

  get subscribeButton() {
    const subscribeButtonText = this.subscribeButtonText;

    if (!subscribeButtonText) {
      return null;
    }

    return (
      <Button styleName={this.buttonStyleName}
              dataHook="subscribe-button"
              className="qa-widget-overlay-subscribe-button"
              onClick={this.openSubscription}>
        {subscribeButtonText}
      </Button>
    );
  }

  get buttons() {
    return (
      <div styleName="buttons">
        {this.playButton}
        {this.subscribeButton}
      </div>
    );
  }

  get coverUrl() {
    const { videoItem, channelData } = this.props;

    let coverUrl = videoItem.customCoverUrl || videoItem.coverUrl;

    if (this.isChannelCoverView) {
      coverUrl = channelData.customCoverUrl || channelData.coverUrl || coverUrl;
    }

    return coverUrl;
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/_base-member-only-overlay.js